import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import type EmberStore from "cc-frontend/services/ember-store"

export default class CalendarRoute extends Route {
  @service("ember-store") declare store: EmberStore

  model(params) {
    return this.modelFor("new-group.show")
  }
}
